import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="cr-footer" style={{ marginTop: 0 }}>
      <div className="page-container">

        {/* Top grid */}
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
            gap: '48px 32px',
            paddingBottom: 56,
            borderBottom: '1px solid rgba(255,255,255,0.1)',
          }}
        >
          {/* Brand */}
          <div>
            <p style={{ fontFamily: 'var(--serif)', fontSize: 22, color: 'var(--ivory)', marginBottom: 16 }}>
              Contractor Rob Flooring
            </p>
            <p style={{ fontFamily: 'var(--sans)', fontSize: 13, color: 'rgba(255,255,255,0.6)', lineHeight: 1.65 }}>
              Premium Luxury Vinyl Plank collections crafted for elegance, durability, and lasting beauty.
            </p>
            <p
              style={{
                fontFamily: 'var(--serif)',
                fontStyle: 'italic',
                fontSize: 14,
                color: 'rgba(255,255,255,0.45)',
                marginTop: 16,
                lineHeight: 1.5,
              }}
            >
              "We provide quality flooring, and that's a promise you can stand on."
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4>Navigation</h4>
            <ul style={{ listStyle: 'none' }}>
              {[
                { label: 'Home',               to: '/'       },
                { label: 'About',              to: '/about'  },
                { label: 'Wholesale',     to: '/catalog' },
              ].map((link) => (
                <li key={link.to}>
                  <Link to={link.to}>{link.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4>Contact</h4>
            <p style={{ fontFamily: 'var(--sans)', fontSize: 14, color: 'rgba(255,255,255,0.6)', lineHeight: 1.7 }}>
              Love3 Products, Inc.<br />
              900 Faulk Road, Suite 201<br />
              Wilmington, DE 19803
            </p>
            <a
              href="mailto:Info@contractorrob.com"
              style={{ display: 'block', marginTop: 12 }}
            >
              Info@contractorrob.com
            </a>
            <a href="https://www.contractorrob.com" style={{ display: 'block', marginTop: 4 }}>
              contractorrob.com
            </a>
          </div>

          {/* Certifications */}
          <div>
            <h4>Standards</h4>
            {['FloorScore Certified', 'CE Marked', 'NFPA Class 2', 'Unilin Click Lock', '100% Waterproof'].map((s) => (
              <p key={s} style={{ fontFamily: 'var(--sans)', fontSize: 13, color: 'rgba(255,255,255,0.55)', padding: '3px 0' }}>
                {s}
              </p>
            ))}
          </div>
        </div>

        {/* Bottom bar */}
        <div
          className="flex items-center justify-between"
          style={{
            paddingTop: 28,
            flexWrap: 'wrap',
            gap: 16,
          }}
        >
          <p style={{ fontFamily: 'var(--sans)', fontSize: 11, color: 'rgba(255,255,255,0.3)', letterSpacing: '0.06em' }}>
            © {new Date().getFullYear()} Love3 Products, Inc. All rights reserved.
          </p>
          <Link
            to="/cookies"
            style={{
              fontFamily: 'var(--sans)',
              fontSize: 11,
              color: 'rgba(255,255,255,0.3)',
              letterSpacing: '0.06em',
              transition: 'color 0.25s',
            }}
            onMouseEnter={e => e.currentTarget.style.color = 'var(--saffron)'}
            onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.3)'}
          >
            Cookie Policy
          </Link>
        </div>
      </div>
    </footer>
  );
}
